import * as Icons from '@mui/icons-material';
import { unwrapXmlStyleContent } from './apiFieldText';
const iconMap = {
    Info: Icons.Info,
    ArrowForward: Icons.ArrowForward,
    Link: Icons.Link,
    Language: Icons.Language,
    LooksOne: Icons.LooksOne,
    LooksTwo: Icons.LooksTwo,
    Looks3: Icons.Looks3,
    Looks4: Icons.Looks4,
    Looks5: Icons.Looks5,
    Looks6: Icons.Looks6,
    Star: Icons.Star,
    Search: Icons.Search,
    Description: Icons.Description,
    Assignment: Icons.Assignment,
    Business: Icons.Business,
    AccountBalance: Icons.AccountBalance,
    ContactPhone: Icons.ContactPhone,
    Help: Icons.Help,
    Speed: Icons.Speed,
    CheckCircle: Icons.CheckCircle,
    Groups: Icons.Groups,
    TrendingUp: Icons.TrendingUp,
    Gavel: Icons.Gavel,
    EventNote: Icons.EventNote,
    Announcement: Icons.Announcement,
    Person: Icons.Person,
    Home: Icons.Home,
    Menu: Icons.Menu,
    Close: Icons.Close,
    Phone: Icons.Phone,
    Email: Icons.Email,
    LocationOn: Icons.LocationOn,
    AccessTime: Icons.AccessTime,
    NewReleases: Icons.NewReleases,
    VerifiedUser: Icons.VerifiedUser,
    Payment: Icons.Payment,
    Refresh: Icons.Refresh,
    Launch: Icons.Launch,
    ArrowRight: Icons.ArrowRight,
    GridView: Icons.GridView,
    Forest: Icons.Forest,
    Login: Icons.Login,
    CheckBox: Icons.CheckBox,
    Security: Icons.Security,
    Apartment: Icons.Apartment,
    DirectionsCar: Icons.DirectionsCar,
    Work: Icons.Work,
    LocalHospital: Icons.LocalHospital,
    PrecisionManufacturing: Icons.PrecisionManufacturing,
    Diversity3: Icons.Diversity3,
    Park: Icons.Park,
    Hiking: Icons.Hiking,
    AccountCircle: Icons.AccountCircle,
    Public: Icons.Public,
};
/** Font Awesome–style names (lowercase / kebab) → MUI icon keys used in `iconMap`. */
const FA_LIKE_ALIASES = {
    account: 'AccountCircle',
    public: 'Public',
    user: 'Person',
    home: 'Home',
    business: 'Business',
    building: 'Apartment',
    car: 'DirectionsCar',
    hospital: 'LocalHospital',
    industry: 'PrecisionManufacturing',
    forest: 'Forest',
    park: 'Park',
    leaf: 'Park',
    globe: 'Language',
};
function resolveIconMapKey(raw) {
    const cleaned = unwrapXmlStyleContent(raw).trim();
    if (!cleaned)
        return 'Info';
    if (cleaned in iconMap)
        return cleaned;
    const lower = cleaned.toLowerCase();
    if (lower in FA_LIKE_ALIASES)
        return FA_LIKE_ALIASES[lower];
    const pascal = cleaned
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join('');
    if (pascal in iconMap)
        return pascal;
    const firstUpper = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    if (firstUpper in iconMap)
        return firstUpper;
    return 'Info';
}
export function getIconByName(name) {
    const key = resolveIconMapKey(name);
    return iconMap[key] ?? Icons.Info;
}
